module.exports = __webpack_public_path__ + "img/facade-2.517bcd7d.jpg";